/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface DeletePlannedAuthSupportsTransferToSubscription$Params {

/**
 * The object ID. Must be a valid ID.
 */
  uid: string;

/**
 * The planned transfer's uid
 */
  transferUid: string;
}

export function deletePlannedAuthSupportsTransferToSubscription(http: HttpClient, rootUrl: string, params: DeletePlannedAuthSupportsTransferToSubscription$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, deletePlannedAuthSupportsTransferToSubscription.PATH, 'delete');
  if (params) {
    rb.path('uid', params.uid, {});
    rb.path('transferUid', params.transferUid, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

deletePlannedAuthSupportsTransferToSubscription.PATH = '/subscriptions/{uid}/auth-supports/transfer/planned/{transferUid}';
